import axios from 'axios';

// Reads the backend's JSON error even when the request used responseType: 'blob'.
export async function blobErrorDetail(error, fallback = 'Download failed') {
  try {
    const blob = error?.response?.data;
    if (blob && typeof blob.text === 'function') {
      const text = await blob.text();
      try { return JSON.parse(text)?.detail || text || fallback; } catch { return text || fallback; }
    }
    if (typeof error?.response?.data?.detail === 'string') return error.response.data.detail;
  } catch (_) { /* ignore */ }
  return fallback;
}

// GET a file from the API and trigger a browser download (filename from Content-Disposition when present).
export async function downloadFile(url, fallbackName) {
  const res = await axios.get(url, { responseType: 'blob' });
  const cd = res.headers?.['content-disposition'] || '';
  const match = cd.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
  const name = match ? decodeURIComponent(match[1].trim()) : fallbackName;
  const href = window.URL.createObjectURL(new Blob([res.data]));
  const link = document.createElement('a');
  link.href = href;
  link.setAttribute('download', name);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(href);
  return name;
}
